define([
	"dojo/_base/declare",
	"csi/service/sessionService",
	"csi/table/Edit"
], function(declare,{ initializeRoles },Edit) {

	return declare(Edit, {
		postProcessSuccess: function() {
			// summary: if this role is a played role, then re-initialize header roles
			if (this.getNode().ManagePreferences) {
				initializeRoles();
			}

			return this.inherited(arguments);
		}
	});
});